require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/library/fn/get-iterator.js
// module id = 861
// module chunks = 106